import { useState, useEffect } from "react";
import api from "../api/client";

export default function NextAppointmentBanner() {
  const [appt, setAppt] = useState(null);

  useEffect(() => {
    api.get("/calendar/next-appointment")
      .then(r => setAppt(r.data.appointment))
      .catch(() => setAppt(null));
  }, []);

  if (!appt) return null;

  return (
    <div
      className="glass-card rounded-xl sm:rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 border-l-4 border-[#C9A86A]"
      data-testid="student-next-appointment-banner"
    >
      <div className="w-11 h-11 rounded-xl bg-[#FFF7E6] flex items-center justify-center shrink-0">
        <svg className="w-5 h-5 text-[#C9A86A]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <div className="min-w-0">
        <p className="text-xs uppercase tracking-wide text-gray-400">Prochain rendez-vous</p>
        <p className="font-semibold text-gray-900 truncate" data-testid="student-next-appointment-name">{appt.name}</p>
      </div>
      <p className="text-sm font-medium text-[#C9A86A] sm:ml-auto" data-testid="student-next-appointment-date">
        {appt.start_local}
      </p>
    </div>
  );
}
